export var EDIRECTION_PAGE = /*#__PURE__*/ function(EDIRECTION_PAGE) {
    EDIRECTION_PAGE["ACCOUNT_OPENING"] = "/accountopening";
    EDIRECTION_PAGE["ACCOUNTS"] = "/accounts";
    EDIRECTION_PAGE["SALARY_CARD"] = "/cards/salary?orderType=NEW_CARD&cardType=SALARY";
    EDIRECTION_PAGE["BUSINESS"] = "/cards/business?orderType=NEW_CARD&cardType=BUSINESS";
    EDIRECTION_PAGE["CUSTOMS"] = "/cards/customs?orderType=NEW_CARD&cardType=CUSTOMS";
    EDIRECTION_PAGE["ENTREPRENEUR"] = "/cards/entrepreneur?orderType=NEW_CARD&cardType=ENTREPRENEUR";
    EDIRECTION_PAGE["CORPORATE"] = "/cards/corporate?orderType=NEW_CARD&cardType=CORPORATE";
    EDIRECTION_PAGE["TAD"] = "/loan/order/tad/2505/calculator/01126439-1b20-11ee-a9eb-0a580a6416b3";
    EDIRECTION_PAGE["TRANCHE"] = "/loan/order/tranche/create";
    EDIRECTION_PAGE["LOAN"] = "/loan?page-number=1&page-size=10";
    EDIRECTION_PAGE["GUARANTEE"] = "/guarantee?page-number=1&page-size=10";
    EDIRECTION_PAGE["DEPOSIT"] = "/deposits?page-number=1&page-size=10";
    EDIRECTION_PAGE["OWN_ACCOUNTS"] = "/payment/own_accounts/create";
    EDIRECTION_PAGE["INTERNAL"] = "/payment/internal/create";
    EDIRECTION_PAGE["DOMESTIC"] = "/payment/domestic/create";
    EDIRECTION_PAGE["IBMG"] = "/payment/ibmg/create";
    EDIRECTION_PAGE["IBTF"] = "/payment/ibtf/create";
    EDIRECTION_PAGE["INTERNATIONAL"] = "/payment/international/create";
    EDIRECTION_PAGE["TAX"] = "/payment/tax/create";
    EDIRECTION_PAGE["VAT"] = "/payment/vat/create";
    EDIRECTION_PAGE["BULK"] = "/payment/bulk/create";
    EDIRECTION_PAGE["SALARY"] = "/payment/salary/create";
    EDIRECTION_PAGE["EXCHANGE"] = "/payment/exchange/create";
    EDIRECTION_PAGE["TEMPLATES"] = "/payment/templates?page=1";
    EDIRECTION_PAGE["GPP"] = "/gpp/create";
    EDIRECTION_PAGE["ANIPAY"] = "/anipay/create?tab=anipay&page=1";
    EDIRECTION_PAGE["POS_TERMINAL"] = "/pos/pos_create";
    EDIRECTION_PAGE["POS"] = "/pos/ecom_create";
    EDIRECTION_PAGE["INVEST"] = "/invest";
    EDIRECTION_PAGE["REPORTS"] = "/reports";
    EDIRECTION_PAGE["ORDERS"] = "/orders?page=1";
    EDIRECTION_PAGE["BUNDLE"] = "/tariff-packages";
    EDIRECTION_PAGE["OTHER_SERVICES"] = "/other-services";
    return EDIRECTION_PAGE;
}({});
